module.exports = __webpack_public_path__ + "img/plane.1e1ebdac.png";